/*
  Invoice ("Έκδοση Τιμολογίου") fields for the cart page and the cart drawer.

  The cart drawer markup is re-injected with innerHTML by cart-drawer.js every
  time the cart changes, which strips all listeners (and never runs inline
  <script> tags). So this file exposes an idempotent init that is re-run on
  every DOM update instead of only on DOMContentLoaded.
*/
(function () {
  var VARIANTS = [
    {
      checkbox: 'invoiceIssue',
      hidden: 'invoiceHidden',
      fields: 'invoiceForm',
      afm: 'invoiceAfm',
      cartForm: 'cart',
    },
    {
      checkbox: 'CartDrawer-invoiceIssue',
      hidden: 'CartDrawer-invoiceHidden',
      fields: 'CartDrawer-invoiceForm',
      afm: 'CartDrawer-invoiceAfm',
      cartForm: 'CartDrawer-Form',
    },
  ];

  function applyState(fieldsEl, hidden, inputs, isChecked) {
    hidden.value = isChecked ? 'ΝΑΙ' : 'Όχι';
    fieldsEl.style.display = isChecked ? 'flex' : 'none';
    inputs.forEach(function (input) {
      input.disabled = !isChecked;
    });
  }

  function validate(fieldsEl, inputs, afmInput) {
    var hasEmpty = false;
    var afmInvalid = false;

    inputs.forEach(function (input) {
      input.style.borderColor = '';
      if (input.value.trim() === '') {
        input.style.borderColor = '#ff0000';
        hasEmpty = true;
      }
    });

    if (afmInput && afmInput.value.trim() !== '' && afmInput.value.trim().length !== 9) {
      afmInput.style.borderColor = '#ff0000';
      afmInvalid = true;
    }

    if (!hasEmpty && !afmInvalid) return true;

    fieldsEl.scrollIntoView({ behavior: 'smooth' });
    var messages = [];
    if (hasEmpty) messages.push('Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία τιμολογίου.');
    if (afmInvalid) messages.push('Το ΑΦΜ πρέπει να έχει 9 ψηφία.');
    alert(messages.join(' '));
    return false;
  }

  function initVariant(config) {
    var checkbox = document.getElementById(config.checkbox);
    var hidden = document.getElementById(config.hidden);
    var fieldsEl = document.getElementById(config.fields);
    if (!checkbox || !hidden || !fieldsEl) return;

    var inputs = Array.prototype.slice.call(fieldsEl.querySelectorAll('input[type="text"]'));
    var afmInput = document.getElementById(config.afm);

    if (fieldsEl.dataset.invoiceBound !== 'true') {
      fieldsEl.dataset.invoiceBound = 'true';

      // Sync invoice field values across drawer <-> cart page (latest input wins)
      inputs.forEach(function (input) {
        var key = 'invoice_' + input.name;
        var stored = sessionStorage.getItem(key);
        if (stored !== null) input.value = stored;

        input.addEventListener('input', function () {
          sessionStorage.setItem(key, this.value);
        });

        ['change', 'input', 'keydown', 'keyup'].forEach(function (evt) {
          input.addEventListener(evt, function (event) {
            event.stopPropagation();
          });
        });
      });

      if (afmInput) {
        afmInput.addEventListener('input', function () {
          this.value = this.value.replace(/\D/g, '').slice(0, 9);
        });
      }

      // Sync the "issue invoice" checkbox state as well
      var storedIssue = sessionStorage.getItem('invoice_issue');
      if (storedIssue !== null) checkbox.checked = storedIssue === 'ΝΑΙ';

      checkbox.addEventListener('change', function (event) {
        event.stopPropagation();
        sessionStorage.setItem('invoice_issue', this.checked ? 'ΝΑΙ' : 'Όχι');
        applyState(fieldsEl, hidden, inputs, this.checked);
      });

      applyState(fieldsEl, hidden, inputs, checkbox.checked);
    }

    var cartForm = document.getElementById(config.cartForm);
    if (cartForm && cartForm.dataset.invoiceBound !== 'true') {
      cartForm.dataset.invoiceBound = 'true';
      cartForm.addEventListener('submit', function (event) {
        if (!checkbox.checked) return;
        if (!validate(fieldsEl, inputs, afmInput)) event.preventDefault();
      });
    }
  }

  function init() {
    VARIANTS.forEach(initVariant);
  }

  window.initInvoiceFields = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The cart drawer / cart page sections are re-rendered with innerHTML, which
  // replaces these nodes with unbound copies. Re-init whenever the DOM changes.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', init);
})();
